
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Widgets } from 'shared/presenters/graphqlTypes';
import { FETCH_WIDGET } from 'library/pages/Activity';
import fetchPageData from 'shared/helpers/fetchPageData';
type Data = {
    widgets: Widgets[];
};
const query = FETCH_WIDGET;
const formatData = (data: Data) => {
    const widgetJSON = data?.widgets[0];
    const outlet = widgetJSON?.outlet;
    const activity = outlet?.schedulables?.[0];
    return { outlet, activity };
};
const fetchActivityPageData = (variables: {
    widgetSlug: string;
    activitySlug: string;
    locale: string;
}) => fetchPageData<Data, typeof formatData>({
    query,
    variables,
    formatData
});
export default fetchActivityPageData;

    async function __Next_Translate__getStaticProps__1961a27d225__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Activity/fetchActivityPageData',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1961a27d225__ as getStaticProps }
  